// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3-3Rm","active":"downloadDropdown_active__3oqJz"};